/**
 * Centralized localStorage keys definition
 * All localStorage keys used throughout the application should be defined here
 * to avoid dynamic key creation and ensure consistency.
 */

export const LOCAL_STORAGE_KEYS = {
  // LINE user profile data
  LINE_USER_ID: 'lineUserId',
  LINE_USER_DISPLAY_NAME: 'lineUserDisplayName',
  LINE_USER_PICTURE_URL: 'lineUserPictureUrl',
  LINE_USER_EMAIL: 'lineUserEmail',
  LINE_USER_LANGUAGE: 'lineUserLanguage',
  LINE_USER_STATUS_MESSAGE: 'lineUserStatusMessage',
  
  // User event tracking - these should be used with helper functions
  // to create specific event keys when needed
  USER_EVENT_PREFIX: 'user-event-',
} as const;

/**
 * Helper functions for creating localStorage keys that need dynamic parts
 */
export const createUserEventKey = (eventKey: string): string => {
  return `${LOCAL_STORAGE_KEYS.USER_EVENT_PREFIX}${eventKey}`;
};

/**
 * Type-safe localStorage wrapper functions
 */
export const localStorage = {
  getItem: (key: string): string | null => {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(key);
  },
  
  setItem: (key: string, value: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, value);
  },
  
  removeItem: (key: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
  },
  
  clear: (): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.clear();
  },
};